import React from 'react'
import { ColumnsType } from 'antd/es/table'
import { AssignManagerTrigger } from 'features/manager/assign/assign-manager-trigger'
import { Link } from 'react-router-dom'
import { getPagePath } from 'router/utils'
import { ReadAreaDto } from 'api-client'
import { Switch } from 'antd'

export const getAreaListColumns = (toggleArea: any): ColumnsType<ReadAreaDto> => [
  {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
    render: (item) => <Link to={`${getPagePath('owner/areas')}/${item}`}>{item}</Link>,
  },
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: 'Address',
    dataIndex: 'address',
    key: 'address',
  },
  {
    title: 'Status',
    render: (item: ReadAreaDto) => (
      <div>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor="cbx1">
          <Switch
            id="cbx1"
            checked={item.isEnabled}
            onChange={(checked) => {
              toggleArea(item.id, checked)
            }}
          />
        </label>
      </div>
    ),
  },
  {
    title: 'Attach',
    render: (item: ReadAreaDto) => <AssignManagerTrigger areaId={item.id} />,
  },
]
